import { Component, OnInit } from '@angular/core';
import { AuthenticationService } from '../../services/authentication.service';
import { publicMethods } from '../../globals';
import { apiUrl } from '../../api-url';
import { CookieService } from 'ngx-cookie';

@Component({
    selector: 'sso-login',
    templateUrl: './sso-login.component.html',
    styleUrls: ['./sso-login.component.css'],
    standalone: false
})
export class SsoLoginComponent implements OnInit {
    email: string = '';
    isLoading: boolean = false;
    providerName: string = '';
    ssoLoginUrl: string = '';
    ssoNotFound: boolean = false;
    showConfirmation: boolean = false;
    csrfToken: string = '';

    constructor(
        private auth: AuthenticationService,
        private pubMethods: publicMethods,
        private cookieService: CookieService
    ) {}

    ngOnInit(): void {
        this.csrfToken = this.cookieService.get('csrftoken') || '';
    }

    onEmailSubmit(): void {
        if (!this.email || !this.email.includes('@')) {
            this.pubMethods.showInfoMessage('Please enter a valid email address.');
            return;
        }

        this.isLoading = true;
        this.ssoNotFound = false;
        this.showConfirmation = false;

        this.auth.getSsoLoginUrl(this.email).subscribe(response => {
            this.isLoading = false;
            
            if (response.sso_enabled) {
                this.providerName = response.provider_name;
                this.ssoLoginUrl = `${apiUrl}/accounts/saml/${response.provider_slug}/login/`;
                this.showConfirmation = true;
            } else {
                this.ssoNotFound = true;
            }
        });
    }

    goBack(): void {
        this.showConfirmation = false;
        this.ssoNotFound = false;
    }
}
